import {CAMPAIGN_NODE_ID, NEW_OUTPUT_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {z} from 'zod';
import {CardConnectionType} from './cardsConnectionTool.enums';

interface ConnectionRequest {
  sourceCardId: number;
  sourceCardOutputId: number;
  targetCardId: number;
  type: CardConnectionType;
}

const cardsConnectionToolSchema = z.object({
  connections: z.array(
    z.object({
      sourceCardId: z
        .number()
        .describe(
          `The ID of the source card, for campaign card the ID will always be ${CAMPAIGN_NODE_ID}`,
        ),
      sourceCardOutputId: z
        .number()
        .describe(
          `The ID of the output on the source card, for campaign card the ID will always be ${NEW_OUTPUT_ID}`,
        ),
      targetCardId: z.number().describe('The ID of the target card to connect to'),
      type: z.nativeEnum(CardConnectionType).describe('Whether to connect or disconnect the cards'),
    }),
  ),
});

export {cardsConnectionToolSchema, ConnectionRequest};
